import axios from 'axios';

const resolveToken = async (token) => {
  const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/work-sessions/resolve/${token}`);
  return data;
};

const getSession = async (token) => {
  const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/work-sessions/session/${token}`);
  return data;
};

const clockIn = async (token) => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/work-sessions/clock-in/${token}`);
  return data;
};

const clockOut = async (token) => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/work-sessions/clock-out/${token}`);
  return data;
};

const getActiveSessions = async () => {
  const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/work-sessions/active`);
  return data.sessions;
};

const adminCloseSession = async (timeEntryId, endTime) => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/work-sessions/admin-close/${timeEntryId}`, { endTime });
  return data;
};

const workSessionService = {
  resolveToken,
  getSession,
  clockIn,
  clockOut,
  getActiveSessions,
  adminCloseSession
};

export default workSessionService;
